import React, { useEffect, useState } from 'react'
import LoshuGrid from '../components/elements/LoshuGrid'

const BasicJanmankCalculator = () => {

    const [dateInput, setDateInput] = useState(false)
    const [result, setResult] = useState(false)

    const data = {
        mulanks: {
            "m1": {
                title: "The Independent",
                strengths: ["Bold", "Innovative", "Confident", "Self-driven"],
                weaknesses: ["Dominating", "Egoistic", "Impatient"],
                personality: "Natural-born leader. Prefers taking initiative and dislikes being told what to do.",
                challenges: "Handling authority with grace, learning humility.",
                advice: "Use leadership to empower others, not control them."
            },
            "m2": {
                title: "The Harmonizer",
                strengths: ["Diplomatic", "Intuitive", "Empathetic"],
                weaknesses: ["Over-sensitive", "Indecisive", "Dependent"],
                personality: "Gentle and emotionally sensitive. Seeks peace and avoids conflict.",
                challenges: "Standing up for oneself without guilt.",
                advice: "Balance giving with receiving; assert your needs too."
            },
            "m3": {
                title: "The Performer",
                strengths: ["Creative", "Expressive", "Charming"],
                weaknesses: ["Frivolous", "Attention-seeking", "Disorganized"],
                personality: "Witty and social. Loves to entertain, create, and be admired.",
                challenges: "Channeling creativity with discipline.",
                advice: "Don't hide behind humor—show your real self too."
            },
            "m4": {
                title: "The Builder",
                strengths: ["Organized", "Loyal", "Practical"],
                weaknesses: ["Stubborn", "Rigid", "Overcautious"],
                personality: "Disciplined and reliable. Seeks routine and long-term stability.",
                challenges: "Opening up emotionally, embracing change.",
                advice: "Use structure as a foundation—not a cage."
            },
            "m5": {
                title: "The Explorer",
                strengths: ["Adventurous", "Quick-thinking", "Adaptable"],
                weaknesses: ["Impulsive", "Unstable", "Overindulgent"],
                personality: "Craves freedom and variety. Gets bored with routine.",
                challenges: "Developing consistency without losing spark.",
                advice: "Focus your energy—don’t scatter it."
            },
            "m6": {
                title: "The Caregiver",
                strengths: ["Responsible", "Compassionate", "Loving"],
                weaknesses: ["Overprotective", "Controlling", "Self-sacrificing"],
                personality: "Feels happiest when helping or nurturing others.",
                challenges: "Avoiding martyrdom and codependency.",
                advice: "Care deeply—but also care for yourself."
            },
            "m7": {
                title: "The Thinker",
                strengths: ["Analytical", "Spiritual", "Reserved"],
                weaknesses: ["Aloof", "Overcritical", "Emotionally distant"],
                personality: "Private and thoughtful. Seeks depth over surface interaction.",
                challenges: "Balancing logic and intuition.",
                advice: "Let people into your world—slowly but surely."
            },
            "m8": {
                title: "The Executive",
                strengths: ["Ambitious", "Efficient", "Strategic"],
                weaknesses: ["Workaholic", "Domineering", "Cynical"],
                personality: "Seeks control, respect, and results.",
                challenges: "Letting go of the need to dominate outcomes.",
                advice: "Power is a tool—use it ethically."
            },
            "m9": {
                title: "The Giver",
                strengths: ["Compassionate", "Idealistic", "Universal thinker"],
                weaknesses: ["Overidealistic", "Neglectful of self", "Detached"],
                personality: "Emotionally rich and humanitarian. Seeks purpose in helping.",
                challenges: "Not losing self in the service of others.",
                advice: "Balance global empathy with personal grounding."
            }
        },
        bhagyanks: {
            "b1": {
                title: "Destined Leader",
                strengths: ["Trailblazing", "Visionary", "Self-reliant"],
                weaknesses: ["Ego-driven", "Impatient", "Isolated"],
                lifePurpose: "To lead and inspire with originality and courage.",
                challenges: "Avoiding loneliness and authoritarianism.",
                advice: "Lead by example—not by force."
            },
            "b2": {
                title: "Destined Peacemaker",
                strengths: ["Diplomatic", "Supportive", "Emotionally intelligent"],
                weaknesses: ["Over-accommodating", "Conflict-averse", "Unassertive"],
                lifePurpose: "To bring harmony and unity in relationships and communities.",
                challenges: "Being passive or overly dependent on others.",
                advice: "Use your sensitivity as strength, not a shield."
            },
            "b3": {
                title: "Destined Communicator",
                strengths: ["Creative", "Inspiring", "Uplifting"],
                weaknesses: ["Inconsistent", "Scattered", "Superficial"],
                lifePurpose: "To express beauty, joy, and wisdom through creativity and speech.",
                challenges: "Turning ideas into actions.",
                advice: "Stay focused—don’t be all talk, no walk."
            },
            "b4": {
                title: "Destined Builder",
                strengths: ["Methodical", "Practical", "Responsible"],
                weaknesses: ["Overly rigid", "Fear of change", "Workaholic"],
                lifePurpose: "To build strong foundations for self and society.",
                challenges: "Balancing stability with growth.",
                advice: "Trust change—it’s part of building too."
            },
            "b5": {
                title: "Destined Explorer",
                strengths: ["Flexible", "Courageous", "Adventurous"],
                weaknesses: ["Impulsive", "Avoids responsibility", "Addictive"],
                lifePurpose: "To experience freedom, teach adaptability, and embrace change.",
                challenges: "Grounding wild energy into purpose.",
                advice: "Use your freedom to inspire—not escape."
            },
            "b6": {
                title: "Destined Nurturer",
                strengths: ["Responsible", "Loyal", "Protective"],
                weaknesses: ["Over-sacrificing", "Controlling", "Judgmental"],
                lifePurpose: "To serve, teach, and bring harmony to families and communities.",
                challenges: "Letting go of control and allowing others to grow.",
                advice: "Serve from love—not obligation."
            },
            "b7": {
                title: "Destined Seeker",
                strengths: ["Wise", "Philosophical", "Spiritual"],
                weaknesses: ["Detached", "Withdrawn", "Overanalyzing"],
                lifePurpose: "To discover deeper truths and guide others with insight.",
                challenges: "Isolation and emotional disconnect.",
                advice: "Don’t lose yourself in thought—live your truth too."
            },
            "b8": {
                title: "Destined Authority",
                strengths: ["Ambitious", "Strategic", "Resilient"],
                weaknesses: ["Materialistic", "Controlling", "Harsh"],
                lifePurpose: "To achieve success, manage power, and make lasting impact.",
                challenges: "Balancing power with empathy.",
                advice: "Use power to lift, not dominate."
            },
            "b9": {
                title: "Destined Healer",
                strengths: ["Empathic", "Generous", "Wise"],
                weaknesses: ["Martyr complex", "Overwhelmed", "Escapist"],
                lifePurpose: "To serve humanity, offer healing, and bring spiritual growth.",
                challenges: "Avoiding emotional burnout.",
                advice: "Set boundaries—giving doesn’t mean sacrificing self."
            }
        },
        career: {
            m1: {
                career: "Independent careers suit you best. You thrive where leadership and initiative are required.",
                business: ["Startups", "Consultancy", "Tech Innovation"],
                job: ["CEO roles", "Team Lead", "Military", "Strategy Analyst"]
            },
            m2: {
                career: "Supportive, cooperative environments help you shine. You're great in people-focused roles.",
                business: ["Counseling Services", "Partnership Firms", "Event Planning"],
                job: ["HR", "Mediator", "Counselor", "Assistant Manager"]
            },
            m3: {
                career: "You excel in expressive, creative, and artistic careers. Communication is your strength.",
                business: ["Advertising", "Design Studio", "Entertainment Media"],
                job: ["Writer", "Public Relations", "Marketing", "Artist"]
            },
            m4: {
                career: "Stable, well-structured careers suit your practical and methodical mindset.",
                business: ["Construction", "Manufacturing", "Real Estate"],
                job: ["Engineer", "Architect", "Accountant", "Project Manager"]
            },
            m5: {
                career: "You thrive in dynamic, change-oriented roles. Routine kills your creativity.",
                business: ["Travel Agency", "Trading", "Media Production"],
                job: ["Sales Executive", "Journalist", "Digital Marketer", "Pilot"]
            },
            m6: {
                career: "Service-oriented fields that allow you to care for and support others suit you best.",
                business: ["Education Center", "Healthcare Clinic", "NGO"],
                job: ["Teacher", "Doctor", "Social Worker", "Psychologist"]
            },
            m7: {
                career: "Research and analysis-based careers match your introspective and intellectual nature.",
                business: ["Spiritual Coaching", "Research Labs", "Tech Consulting"],
                job: ["Scientist", "Researcher", "Philosopher", "Data Analyst"]
            },
            m8: {
                career: "You do well in authoritative roles with responsibility and rewards. Business acumen is strong.",
                business: ["Finance", "Real Estate", "Corporate Enterprises"],
                job: ["Banker", "Business Executive", "CFO", "Judge"]
            },
            m9: {
                career: "You shine in humanitarian or global-impact roles. Idealistic, driven by service.",
                business: ["NGO", "Spiritual Centers", "Charity Foundations"],
                job: ["Diplomat", "Therapist", "Human Rights Lawyer", "Coach"]
            },

            b1: {
                career: "Destined to lead. Careers that let you innovate and guide others fulfill you.",
                business: ["Tech Startups", "Personal Brand Ventures", "Innovation Labs"],
                job: ["Startup Founder", "Product Manager", "Government Officer"]
            },
            b2: {
                career: "Life leads you toward cooperation and harmony — careers in diplomacy and care work best.",
                business: ["Event Coordination", "Therapy Practice", "Conflict Resolution Services"],
                job: ["Counselor", "Nurse", "Mediator", "HR Specialist"]
            },
            b3: {
                career: "Your life path encourages self-expression and joy — creative fields are your destiny.",
                business: ["Publishing House", "Music Production", "Art Gallery"],
                job: ["Performer", "Writer", "Designer", "Spokesperson"]
            },
            b4: {
                career: "You are destined to build and organize — you do best in system-based careers.",
                business: ["Construction", "Architecture", "Logistics Firm"],
                job: ["Engineer", "Auditor", "Operations Manager", "Planner"]
            },
            b5: {
                career: "Life wants you to explore and teach freedom — embrace dynamic, versatile careers.",
                business: ["Adventure Tours", "Tech Startups", "Media Agency"],
                job: ["Travel Blogger", "Sales", "Digital Marketer", "Vlogger"]
            },
            b6: {
                career: "Destined to care and nurture — teaching, medicine, and community service are ideal.",
                business: ["Health & Wellness", "Education Institute", "Home Decor"],
                job: ["Doctor", "Teacher", "Social Worker", "Family Therapist"]
            },
            b7: {
                career: "Your soul's purpose is in wisdom and depth — spiritual and analytical roles suit best.",
                business: ["Spiritual Practice", "R&D Labs", "Tech Think Tanks"],
                job: ["Scientist", "Mystic", "Teacher", "Philosopher"]
            },
            b8: {
                career: "Life path of power and success — you’re destined for executive and financial domains.",
                business: ["Investment Firm", "Large-scale Real Estate", "Corporate Ventures"],
                job: ["Banker", "Politician", "CEO", "Financial Analyst"]
            },
            b9: {
                career: "Your destiny lies in humanitarianism — service, arts, and healing are key.",
                business: ["Charity Work", "Counseling Center", "Publishing"],
                job: ["Healer", "Therapist", "Spiritual Leader", "NGO Director"]
            }
        },
        numberColors: {
            1: 'text-red-400',
            2: 'text-blue-400',
            3: 'text-yellow-400',
            4: 'text-blue-300',
            5: 'text-green-400',
            6: 'text-pink-400',
            7: 'text-cyan-800',
            8: 'text-blue-700',
            9: 'text-red-700',
        }
    }

    function calculateMulankAndBhagyank(dateStr) {

        function reduceToSingleDigit(num) {
            while (num > 9) {
                num = num.toString().split('').reduce((sum, digit) => sum + Number(digit), 0);
            }
            return num;
        }

        if (!dateStr || typeof dateStr !== "string") return false;

        const [yearStr, monthStr, dayStr] = dateStr.split("-");
        const year = Number(yearStr);
        const day = Number(dayStr);

        if (year < 1000 || year > 3000) return false;

        const mulank = reduceToSingleDigit(day);

        const allDigits = [...yearStr, ...monthStr, ...dayStr].map(Number);

        const bhagyank = reduceToSingleDigit(allDigits.reduce((sum, digit) => sum + digit, 0));

        const entities = allDigits.slice()

        return { mulank, bhagyank, entities };
    }

    useEffect(() => {
      setResult(calculateMulankAndBhagyank(dateInput))
    }, [dateInput])
    

  return (
    <>

        <section className="mx-auto max-w-[85rem] py-11">

            
            <div className="max-w-xl mx-auto">   
                <label htmlFor="default-search" className="mb-2 text-sm font-medium leading-loose text-gray-900 sr-only">Search</label>
                <div className="relative">
                    <input onInput={(e) => {setDateInput(e.target.value)}} type="date" className="block w-full p-4 ps-10 text-sm text-gray-600 focus:shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] duration-300 border border-gray-200 rounded-lg outline-none" required />
                </div>
            </div>

            {result && (<div className="max-w-xl mx-auto flex items-center justify-center mt-11">
                <LoshuGrid entities={result.entities} mulank={result.mulank} bhagyank={result.bhagyank} />
            </div>)}

            {result && (<div className="max-w-xl mx-auto mt-11 px-5">

                <h3 className={`text-6xl ${data.numberColors[result.mulank]}`}>{result.mulank}</h3>
                <p>Mulank</p>

                <p className='mt-5'><strong>Title</strong>: {data.mulanks[`m${result.mulank}`].title}</p>
                <p className='mt-2'><strong>Strengths</strong>: {data.mulanks[`m${result.mulank}`].strengths.map( (q, i) => {return data.mulanks[`m${result.mulank}`].strengths.length === i+1 ? q : `${q}, `} )}</p>
                <p className='mt-2'><strong>Weaknesses</strong>: {data.mulanks[`m${result.mulank}`].weaknesses.map( (q, i) => {return data.mulanks[`m${result.mulank}`].weaknesses.length === i+1 ? q : `${q}, `} )}</p>
                <p className='mt-2'><strong>Personality</strong>: {data.mulanks[`m${result.mulank}`].personality}</p>
                <p className='mt-2'><strong>Challenges</strong>: {data.mulanks[`m${result.mulank}`].challenges}</p>
                <p className='mt-2'><strong>Advice</strong>: {data.mulanks[`m${result.mulank}`].advice}</p>
                <p className='mt-2'><strong>Career</strong>: {data.career[`m${result.mulank}`].career}</p>
                <p className='mt-2'><strong>Job Advice</strong>: {data.career[`m${result.mulank}`].job.map( (q, i) => {return data.career[`m${result.mulank}`].job.length === i+1 ? q : `${q}, `} )}</p>
                <p className='mt-2'><strong>Business Advice</strong>: {data.career[`m${result.mulank}`].business.map( (q, i) => {return data.career[`m${result.mulank}`].business.length === i+1 ? q : `${q}, `} )}</p>

            </div>)}

            {result && (<div className="max-w-xl mx-auto mt-11 px-5">

                <h3 className={`text-6xl ${data.numberColors[result.bhagyank]}`}>{result.bhagyank}</h3>
                <p>Bhagyank</p>

                <p className='mt-5'><strong>Title</strong>: {data.bhagyanks[`b${result.bhagyank}`].title}</p>
                <p className='mt-2'><strong>Strengths</strong>: {data.bhagyanks[`b${result.bhagyank}`].strengths.map( (q, i) => {return data.bhagyanks[`b${result.bhagyank}`].strengths.length === i+1 ? q : `${q}, `} )}</p>
                <p className='mt-2'><strong>Weaknesses</strong>: {data.bhagyanks[`b${result.bhagyank}`].weaknesses.map( (q, i) => {return data.bhagyanks[`b${result.bhagyank}`].weaknesses.length === i+1 ? q : `${q}, `} )}</p>
                <p className='mt-2'><strong>Life Purpose</strong>: {data.bhagyanks[`b${result.bhagyank}`].lifePurpose}</p>
                <p className='mt-2'><strong>Challenges</strong>: {data.bhagyanks[`b${result.bhagyank}`].challenges}</p>
                <p className='mt-2'><strong>Advice</strong>: {data.bhagyanks[`b${result.bhagyank}`].advice}</p>
                <p className='mt-2'><strong>Career</strong>: {data.career[`b${result.bhagyank}`].career}</p>
                <p className='mt-2'><strong>Job Advice</strong>: {data.career[`b${result.bhagyank}`].job.map( (q, i) => {return data.career[`b${result.bhagyank}`].job.length === i+1 ? q : `${q}, `} )}</p>
                <p className='mt-2'><strong>Business Advice</strong>: {data.career[`b${result.bhagyank}`].business.map( (q, i) => {return data.career[`b${result.bhagyank}`].business.length === i+1 ? q : `${q}, `} )}</p>

            </div>)}


            {/* <div className="relative overflow-x-auto max-w-4xl mx-auto mt-28 px-5">
                <table className="w-full text-sm text-left text-gray-500">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                            <th scope="col" className="px-6 py-3">
                                Numerology
                            </th>
                            <th scope="col" className="px-6 py-3">
                                Chaldean
                            </th>
                            <th scope="col" className="px-6 py-3">
                                Pythagorean
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="bg-white border-b border-gray-200">
                            <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                Destiny Number
                            </th>
                            <td className="px-6 py-4 text-black">
                                <strong>{result.chaldean[0]}</strong>
                            </td>
                            <td className="px-6 py-4">
                                {result.pythagorean[0]}
                            </td>
                        </tr>
                        <tr className="bg-white border-b border-gray-200">
                            <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                Soul Urge Number
                            </th>
                            <td className="px-6 py-4 text-black">
                                <strong>{result.chaldean[1]}</strong>
                            </td>
                            <td className="px-6 py-4">
                                {result.pythagorean[1]}
                            </td>
                        </tr>
                        <tr className="bg-white border-b border-gray-200">
                            <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                Personality Number
                            </th>
                            <td className="px-6 py-4 text-black">
                                <strong>{result.chaldean[2]}</strong>
                            </td>
                            <td className="px-6 py-4">
                                {result.pythagorean[2]}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div> */}

        </section>

    </>
  )
}

export default BasicJanmankCalculator